import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Axios from "axios";
import { API_CONFIG } from "../../../config/config.jsx";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import Popover from "@material-ui/core/Popover";
import { Input, Button, InputGroup } from "reactstrap";
import moment from "moment";
import pdficon from "./../../../assets/img/pdf.png";
import DownloadIcon from "assets/img/DownloadIcon.png";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

const styles = theme => ({
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    },
  },
  downloadStyle: {
    width: 20,
    height: 20,
    marginLeft: "85%",
    cursor: "pointer",
    marginBottom: "2px"
  }
});

const createWorkbook = records => {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: "SheetJS Tutorial",
    Subject: "Test",
    Author: "Red Stapler",
    CreatedDate: new Date(2019, 12, 19)
  };

  wb.SheetNames.push("Monitoring Report");
  const data = records.data.map(obj => [

    obj.mobile,
    obj.rentType,
    obj.startTime,
    obj.paymentMethodAvailable,
    obj.paymentBy,
    obj.paymentStatus,
    obj.boxScanned,
    obj.rentStoreName,
    obj.powerbankUnlocked,
    obj.powerbankPickedUp,
    obj.errorMessage,
    obj.endTime,
    obj.returnStoreName
  ]);

  
  const ws_data = [
    [
      "Mobile",
      "Rent Type",
      "Rent Start Time",
      "Payment Method Available",
      "Payment Method Type",
      "Payment Status",
      "Box Scanned",
      "Rent Store name",
      "Powerbank Unlocked",
      "Powerbank Picked Up",
      "Error Message",
      "Rent End Time",
      "Return Store Name"
    ],
    ...data
  ];
  const ws = XLSX.utils.aoa_to_sheet(ws_data);
  wb.Sheets["Cable Usage Report"] = ws;
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
  return wbout;
};
const s2ab = s => {
  var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
  var view = new Uint8Array(buf); //create uint8array as viewer
  for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
  return buf;
};
class RentalHistoryReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rentalHistoryData: [],
      // text: ' To ',
      open: false,
      startDate: moment()
        .subtract(30, "days")
        .toDate(),
      endDate: new Date(),
      showDefaultReport: false,
      openPopOver: false
    };
    this.reactTable = React.createRef();
  }
  handleSelect = ranges => {
    this.setState({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
      // dateValue: moment(ranges.selection.startDate).format('MMM-DD-YYYY') + this.state.text + moment(ranges.selection.endDate).format('MMM-DD-YYYY')
    });
  };
  handleClick = event => {
    this.setState({
      open: !this.state.open,
      openPopOver: event.currentTarget
    });
  };
  handleClose = () => {
    this.setState({
      openPopOver: false
    });
  };
  handleApply = () => {
    this.setState(
      {
        openPopOver: false
      },
      () => {
        this.fetchData();
      }
    );
    // const startDate = moment(this.state.startDate).format('DD-MM-YYYY');
    // const endDate = moment(this.state.endDate).format('DD-MM-YYYY');
    // this.props.fetchStandardReportData(startDate, endDate, true);
  };
  componentDidMount() {
    this.fetchData();
  }
  fetchData = () => {
    const token = sessionStorage.getItem("plugoAuthKey");
    const userId = sessionStorage.getItem("plugoUserId");
    // const startDate = moment(this.state.startDate).format("YYYY-MM-DD");
    // const endDate = moment(this.state.endDate).format("YYYY-MM-DD");

    Axios.get(
      `${
        API_CONFIG.HOST
      }/cable/usage/${userId}`,
      {
        headers: {
          "Authorization": `Bearer ${token}`,
          "X-USER-ID": userId
        }
      }
    ).then(res => {
      this.setState({
        rentalHistoryData: res.data
      });
    });
  };
  currentfile = val => {
    let link = "https://" + val;
    var elem = document.createElement("a");
    elem.setAttribute("href", link);
    elem.setAttribute("download", "download");
    elem.click();
  };

   handleExcel = () => {
    const records = this.reactTable.getResolvedState();
    saveAs(
      new Blob([s2ab(createWorkbook(records))], {
        type: "application/octet-stream"
      }),
      "test.xlsx"
    );
  };
  // }
  render() {
    const { classes } = this.props;
    const selectionRange = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      key: "selection"
    };
    let currentNumber = sessionStorage.getItem("plugoUserMobileNo");
    let filterRentalDefaultData = this.state.rentalHistoryData;
    let rentalHistoryData = filterRentalDefaultData.map((row, index) => {
      return {
       // mobile: row.mobile,
      //  rentType: row.rentType,
        deviceId : row.deviceId,
        attempt : row.attempt,
        duration: row.duration,
        startTime: moment(row.createdAt).format("DD.MM.YYYY HH:mm:ss"),
       // paymentMethodAvailable: row.paymentMethodAvailable,
        //paymentBy: row.paymentBy,
      //  paymentStatus: row.paymentStatus,
       // boxScanned: row.boxScanned,
       // rentStoreName: row.rentStoreName,
       // errorMessage: row.errorMessage,
       // endTime: moment(row.endTime).format("DD.MM.YYYY HH:mm:ss"),
       // returnStoreName: row.returnStoreName
      };
    });


    return (
      <div>
        <Card>
          <CardHeader color="success">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <h4 className={classes.cardTitleWhite}>Cable Usage Report</h4>
            <img
                onClick={this.handleExcel}
                title="Download as Excel"
                className={classes.downloadStyle}
                src={DownloadIcon}
              />
              </div>
          </CardHeader>
          <CardBody>
            {/* <div style={{ marginBottom: "10px" }}>
              <InputGroup style={{ width: "50%" }}>
                <Input
                  value={
                    moment(this.state.startDate).format("DD.MM.YYYY") +
                    " To " +
                    moment(this.state.endDate).format("DD.MM.YYYY")
                  }
                  onClick={this.handleClick}
                  autoComplete="off"
                  // placeholder="Select Date Range"
                />
              </InputGroup>
              <Popover
                open={this.state.openPopOver}
                // anchorEl={anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }}
              >
                <div>
                  <DateRange
                    editableDateInputs={true}
                    onChange={this.handleSelect}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    months={2}
                    minDate={moment()
                      .subtract(2, "months")
                      .startOf("month")
                      .toDate()}
                    direction="horizontal"
                    ranges={[selectionRange]}
                  />
                </div>
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ float: "right", margin: "2px 10px" }}
                    onClick={this.handleApply}
                  >
                    Apply
                  </Button>
                </div>
              </Popover>
            </div> */}
            <ReactTable
            ref={r => (this.reactTable = r)}
              data={rentalHistoryData}
              // onFetchData={this.fetchData}
              filterable
              defaultFilterMethod={(filter, row) =>
                String(row[filter.id]) === filter.value
              }
              columns={[
                {
                  headerStyle: { fontSize: "16px", paddingTop: "10px" },
                  style: { textAlign: "center" },
                  minWidth: 10,
                  Header: "Device Id",
                  id: "mobile",
                  accessor: d => d.deviceId,
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["deviceId"] }),
                  filterAll: true
                },
                {
                  headerStyle: { fontSize: "16px", paddingTop: "10px" },
                  style: { textAlign: "center" },
                  minWidth: 10,
                  Header: "Attempt",
                  id: "attempt",
                  accessor: d => d.attempt,
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["attempt"] }),
                  filterAll: true
                },
                {
                  headerStyle: { fontSize: "16px", paddingTop: "10px" },
                  style: { textAlign: "center" },
                  minWidth: 10,
                  Header: "Duration",
                  id: "duration",
                  accessor: d => d.duration,
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["duration"] }),
                  filterAll: true
                },
                {
                  headerStyle: { fontSize: "16px", paddingTop: "10px" },
                  style: { textAlign: "center" },
                  minWidth: 11,
                  Header: "Start Time",
                  id: "startTime",
                  accessor: d => d.startTime,
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["startTime"] }),
                  filterAll: true,
                  sortMethod: (a, b) => {
                    const a1 = moment(a, "LLL");
                    const b1 = moment(b, "LLL");
                    if (a1.isBefore(b1)) return 1;
                    else if (a1.isAfter(b1)) return -1;
                    else return 0;
                  }
                },

                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Payment Method Available",
                //   id: "paymentMethodAvailable",
                //   accessor: d => d.paymentMethodAvailable,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, {
                //       keys: ["paymentMethodAvailable"]
                //     }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Payment Method Type",
                //   id: "paymentBy",
                //   accessor: d => d.paymentBy,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, {
                //       keys: ["paymentBy"]
                //     }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Payment Status",
                //   accessor: "paymentStatus",
                //   id: "paymentStatus",
                //   accessor: d => d.paymentStatus,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, {
                //       keys: ["paymentStatus"]
                //     }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: {
                //     fontSize: "16px",
                //     height: "40px",
                //     paddingTop: "10px"
                //   },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Box Scanned",
                //   id: "boxScanned",
                //   accessor: d => d.boxScanned,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, {
                //       keys: ["boxScanned"]
                //     }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 11,
                //   Header: "Rent Store name",
                //   id: "rentStoreName",
                //   accessor: d => d.rentStoreName,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, { keys: ["rentStoreName"] }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Powerbank Unlocked",
                //   accessor: "powerbankUnlocked",
                //   id: "powerbankUnlocked",
                //   accessor: d => d.powerbankUnlocked,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, { keys: ["powerbankUnlocked"] }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Powerbank Picked Up",
                //   accessor: "powerbankPickedUp",
                //   id: "powerbankPickedUp",
                //   accessor: d => d.powerbankPickedUp,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, {
                //       keys: ["powerbankPickedUp"]
                //     }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Error Message",
                //   accessor: "errorMessage",
                //   id: "errorMessage",
                //   accessor: d => d.errorMessage,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, {
                //       keys: ["errorMessage"]
                //     }),
                //   filterAll: true
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 11,
                //   Header: "Rent End Time",
                //   id: "endTime",
                //   accessor: d => d.endTime,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, { keys: ["endTime"] }),
                //   filterAll: true,
                //   sortMethod: (a, b) => {
                //     const a1 = moment(a, "LLL");
                //     const b1 = moment(b, "LLL");
                //     if (a1.isBefore(b1)) return 1;
                //     else if (a1.isAfter(b1)) return -1;
                //     else return 0;
                //   }
                // },
                // {
                //   headerStyle: { fontSize: "16px", paddingTop: "10px" },
                //   style: { textAlign: "center" },
                //   minWidth: 10,
                //   Header: "Return Store Name",
                //   accessor: "returnStoreName",
                //   id: "returnStoreName",
                //   accessor: d => d.returnStoreName,
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, {
                //       keys: ["returnStoreName"]
                //     }),
                //   filterAll: true
                // }
              ]}
              // defaultPageSize={10}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}
RentalHistoryReport.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RentalHistoryReport);
